import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';
import { getAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import $, { event } from "jquery";
import Constants from "../../../Constants";
import { FILE_TYPE_PREF } from "../../../services/Util";
import DataTable from "react-data-table-component";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { handleError } from "../../../services/authApiRoutes/APImethods";

export default function ProjectSettingOneReview() {
    const scrollRef = useRef(null);
    const { t } = useTranslation();
    const [departmentData,setDepartmentData]=useState([])
    const translate = t;
    const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
    const navigate = useNavigate();
    const[globalOverlay,showGlobalOverlay] = useState(true);
    const backRef = useRef();
    const [loader, showLoader] = useState(true);
    const [prefrenceData,setPrefrenceData]=useState([])

   useEffect(()=>{
      getDepartments();
   },[])
   const theme = aaaSelected ? "dark" : "";
   const getDepartments =()=>{
    showLoader(true)
    Promise.all([
     getAxiosResponse(APIUrls.ALL_DEPARTMENT),
     getAxiosResponse(APIUrls.CUSTOMER_DEPARTMENNT_PREFRENCE),
    ]).then(async ([allDepartmentResponse, preferDepartmentResp]) => {
      if(allDepartmentResponse.data.code === 200){
       showGlobalOverlay(false);   
       showLoader(false)
        let arr=[]
        allDepartmentResponse.data.data.forEach((data)=>{    
          for (const key in preferDepartmentResp?.data?.data) {
            if (Object.hasOwnProperty.call(preferDepartmentResp?.data?.data, key)) {
              const value = preferDepartmentResp?.data?.data[key];
              if(+key === +data.id){
                let prefrence=[];
                value.forEach(d=>{
                  if(d.status==="true"){
                    if(FILE_TYPE_PREF[d.preference]){
                    prefrence.push(FILE_TYPE_PREF[d.preference])
                    }
                  }
                });
                let obj={id:data.id,name:data.name,prefrence:prefrence,status:true}
                 arr.push(obj)
              }
            }
          } 

            
        })
        setDepartmentData(arr)
      }else{
       showGlobalOverlay(false);     
       showLoader(false)
        throw new Error("Department API failed with response" + allDepartmentResponse.data.code);
      }
      if(preferDepartmentResp.data.code === 200){

      }else{
       showLoader(false)
       showGlobalOverlay(false);     
        throw new Error("Prefer Department API failed with response" + allDepartmentResponse.data.code);
      }
    }).catch((err) => {
      handleError(err);
      showGlobalOverlay(false)
    })
   } 

   useEffect(()=>{
    $(".lastdisable").trigger("focus");
  }, [])

   const editPrefrence=(id)=>{
    navigate(`/settings/project-setting-edit-onereview/${id}`)
  }

  const backToSettings=()=>{
    navigate(`/settings`)

  }

  const rowPrefrence=(data)=>{
    let res;
    if(data.length >=2 ){
       res=[data[0],data[1]];
     }else if(data.length === 1){
      res=[data[0]];
     }

     return res;
  }
  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
      .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING });
  };
  const customDepartmentSort = (rowA, rowB) => {
    const a = rowA.name;
    const b = rowB.name;
    if (a > b) {
        return 1;
    }
    if (b > a) {
        return -1;
    }
    return 0;
};

const customPreferenceSort = (rowA, rowB) => {
  const a = Array.isArray(rowA.prefrence)? rowA.prefrence?.join(","):rowA.prefrence;
  const b = Array.isArray(rowB.prefrence)? rowB.prefrence?.join(","):rowB.prefrence;
  if (a > b) {
      return 1;
  }
  if (b > a) {
      return -1;
  }
  return 0;
};

   const columns =[{
    id: "project.Department	",
    name: "Department",
    selector: (row) => row.name,
    sortable: true,
    sortFunction: customDepartmentSort
   },{
    id: "project.prefrence",
    name: "Prefrence",
    selector: (row,index) =><> {rowPrefrence(row.prefrence)?rowPrefrence(row.prefrence).join(", "):"none"}
    <a  onClick={()=>showModel(row?.prefrence)} aria-label={(row?.prefrence.length -2 !==0 ? row?.prefrence.length -2 < 0 ?"":""+(row?.prefrence.length -2) :"" ) + " view more formats"}>  {(row?.prefrence.length -2 !==0 ? row?.prefrence.length -2 < 0 ?"":"+"+(row?.prefrence.length -2) :"" )}</a> </>,
    sortable: true,
    sortFunction: customPreferenceSort

   },
    {
      id: "project.id	",
      name: "Action ",
      sortable: false,
      selector: (row) => <button type="button" onClick={()=>editPrefrence(row.id)} className="inline-flex" aria-label="edit"><svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none"><path d="M15.2521 4.97331C15.6144 4.61106 15.8137 4.12997 15.8137 3.61822C15.8137 3.10647 15.6144 2.62539 15.2521 2.26314L13.7322 0.743224C13.3699 0.380974 12.8889 0.181641 12.3771 0.181641C11.8654 0.181641 11.3843 0.380974 11.023 0.742266L0.833984 10.8996V15.1307H5.06311L15.2521 4.97331ZM12.3771 2.09831L13.898 3.61727L12.3742 5.13526L10.8543 3.61631L12.3771 2.09831ZM2.75065 13.214V11.6951L9.49732 4.96947L11.0172 6.48939L4.27153 13.214H2.75065ZM0.833984 17.0473H16.1673V18.964H0.833984V17.0473Z" fill="#1D4ED8"></path></svg></button>,
      
     }
  ]
 
  $(".rdt_Table").attr("aria-label","OneReview"); 
   $(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
   })

   const hideModel = () => {
    document.body.classList.remove("modal-open");
  };

  const showModel = (data) => {
    setPrefrenceData(data)
    document.body.classList.add("modal-open");
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $(".first-focus").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          e.preventDefault();
            $("#renameId").trigger("focus");
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideModel();
          $('.focusAdd').trigger('focus');
          $('.inline-flex').removeClass('focusAdd');
        }
      });
    }, 500);
  };
  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'OneReview', url:''},
  ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
             <Breadcrumb crumbs={ crumbs } />
             <div className="project-setting-page">
                <div className="project-heading userprofile-heading">
                    <div className="back-arrow flex-center">
                    <button onClick={()=>backToSettings()} aria-label="back" ref={backRef}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                        <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z" fill="#1D4ED8"/>
                        </svg>
                    </button>
                    <span>Back to Settings</span>
                    </div>
                    <h3 className="flex">OneReview</h3>
                    <span>Manage settings for your translation review experience</span>
                </div>
                <div className="white-bg"> 
                    <div className="gb-setting-head">
                      <p>OneReview gives your reviewers the ability to review translations line-by-line or in context in OPAL-Marketing, and comes standard with any OPAL-Marketing integration. Optionally, you can enable OneReview for additional file formats, and also configure the ability for reviewers to edit translations directly.</p>
                      <p>When enabled, the next time you send out a project translating files in any of the enabled file formats, your reviewers will be able to review translations line-by-line or in context in OPAL-Marketing. Please note that to use OneReview, your translation vendors will be asked to translate files using the industry-standard exchange format, XLIFF.</p>
                    </div>
                   
                      
                <div className="datatable-block">
                  <DataTable
                    keyField="id"
                    columns={columns}
                    data={departmentData}
                    theme={theme}
                    progressPending={loader}
                    onSort={handleSort}
                    //defaultSortFieldId="project.Department"
                  />
                </div>
                    
                </div>
             </div>
          </div>
        </section>
      </div>
      <div className='lightbox-panel' aria-labelledby="removelabel" aria-modal="true" role="dialog">
            <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="removelabel">Prefrence</h5>
             </div>
             <div className="lightbox-content padd-22">
               <p className="f16-para">
               {prefrenceData.join(", ")}
               </p>
             </div>	
             <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold first-focus" onClick={hideModel}>Cancel</button>
            </div>
            </div>		
          </div>
      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>    
    </div>
  );
}
